import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'
import datasource from './modules/data-source'

import * as getters from './getters'
import { userInfo } from 'os'
// import {getAdminInfo} from '@/api/getData'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
    datasource
  },
  state: {
    // 存储token
    accessToken: localStorage.getItem('Authorization')
      ? localStorage.getItem('Authorization')
      : '',
    refreshToken: localStorage.getItem('refresh_token')
      ? localStorage.getItem('refresh_token')
      : '',
    expirationTime: localStorage.getItem('startTime')
      ? Number(localStorage.getItem('startTime')) +
        Number(localStorage.getItem('sessionTime')) * 1000
      : '',
    user: { info: {}, permissions: {} }
  },
  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin (state, user) {
      state.accessToken = user.Authorization
      localStorage.setItem('Authorization', user.Authorization)
    },
    setUser (state, user) {
      state.user = user
    }
  },
  actions: {
    setTokenInfo (context) {
      context.commit('changeLogin', userInfo)
    }
  }
})

Vue.use(VuexI18n.plugin, store)
export default store
